module.exports = __webpack_public_path__ + "img/Weapon_169.0fe4f5f9.png";